import React, { Component } from 'react';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import PropTypes from 'prop-types';
import Skeleton from 'react-loading-skeleton';
import {
  Button, List, ListItem, ListItemText, IconButton, ListItemSecondaryAction,
} from '@material-ui/core';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';
import { withRouter } from 'react-router-dom';


class ListMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showing: props.rowsPerPage,
    };
  }

  getMoreLines = () => {
    const { showing } = this.state;
    const { rowsPerPage } = this.props;
    this.setState({ showing: showing + rowsPerPage });
  }

  render() {
    const {
      content, fetched, translate, classes,
    } = this.props;

    const { showing } = this.state;
    const totalHits = content ? content.length : 0;

    return [
      <div key={1} className={classes.mb}>
        <List>
          {content.slice(0, showing).map((val, index) => (
            <ListItem
              className={!(index % 2) ? classes.odd : ''}
              onClick={val.onClick}
              key={val.sysId}
            >
              <ListItemText
                primary={fetched ? val.primary : <Skeleton />}
                secondary={fetched ? val.secondary : <Skeleton />}
              />
              { fetched
              && (
                <ListItemSecondaryAction>
                  <IconButton
                    onClick={val.onClick}
                  >
                    <ArrowForwardIcon color="primary" />
                  </IconButton>
                </ListItemSecondaryAction>
              )}
            </ListItem>
          ))}
        </List>
      </div>,
      <div key={2} className={classes.mb}>
        { fetched
        && showing < totalHits
        && (
          <Button className={classes.mb} fullWidth variant="outlined" color="primary" onClick={() => this.getMoreLines()}>
            {`${translate('defaults.showmore')} (${totalHits - showing})`}
          </Button>
        )}
      </div>,
    ];
  }
}

const styles = () => ({
  mb: {
    marginBottom: '2.5rem',
  },
  odd: {
    backgroundColor: '#f2f2f2',
  },
});

ListMobile.propTypes = {
  content: PropTypes.array,
  fetched: PropTypes.bool.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  translate: PropTypes.any.isRequired,
  classes: PropTypes.object.isRequired,
};

ListMobile.defaultProps = {
  content: [],
};

const mapStateToProps = ({ localize }) => ({
  translate: getTranslate(localize),
});

export default connect(mapStateToProps)(withStyles(styles)(withRouter(ListMobile)));
